import React from 'react';
import classNames from 'classnames';
import Icon from 'material-ui/svg-icons/navigation/chevron-left';

export default class extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon chevron-left', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
